import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {buildTeammateDisplayName} from '../../../../../helpers/modelHelpers';
import {ThreeDots} from '../../../../common/threeDots';
import {CellAuthorWrapper, CellAuthorWrapperProps} from './cellAuthorWrapper';

/*
 * Props.
 */

interface CellReplyingPrecogProps extends CellAuthorWrapperProps {
  isSelected?: boolean;
}

/*
 * Style.
 */

interface CellReplyingPrecogStyleProps {
  $isSelected?: boolean;
}
const StyledPrecogDiv = styled.div<CellReplyingPrecogStyleProps>`
  display: flex;
  height: 20px;
  line-height: 20px;

  padding: 0 8px 0 6px;
  align-items: center;

  border-radius: 4px;
  background-color: ${(p) => (p.$isSelected ? p.theme.cell.selectedBackgroundBubble : p.theme.greys.shade30)};
`;

const StyledAuthorDiv = styled.div<CellReplyingPrecogStyleProps>`
  padding: 3px 0;

  color: ${(p) => (p.$isSelected ? p.theme.invertedText : p.theme.greys.shade80)};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.semibold};

  ${ellipsis()};
`;

const StyledReplyingDiv = styled.div<CellReplyingPrecogStyleProps>`
  flex-shrink: 0;
  padding: 3px 0;
  margin-right: 8px;

  color: ${(p) => (p.$isSelected ? p.theme.invertedText : p.theme.greys.shade70)};
  font-size: ${fontSizes.small};
`;

/*
 * Component.
 */

export const CellReplyingPrecog: FC<CellReplyingPrecogProps> = (props) => {
  const theme = useUserTheme();
  const teammateName = buildTeammateDisplayName(props.author);
  const threeDotsColor = props.isSelected ? theme.greys.white : theme.greys.shade70;
  return (
    <CellAuthorWrapper author={props.author} isSelected={props.isSelected}>
      <StyledPrecogDiv $isSelected={props.isSelected}>
        <StyledAuthorDiv $isSelected={props.isSelected}>{teammateName}</StyledAuthorDiv>
        <StyledReplyingDiv $isSelected={props.isSelected}>
          &nbsp;<Trans id="cell-is-replying">is replying</Trans>
        </StyledReplyingDiv>
        <ThreeDots color={threeDotsColor} size={VisualSizesEnum.SMALL} />
      </StyledPrecogDiv>
    </CellAuthorWrapper>
  );
};
